import Joi from "joi-browser";

const TEMPLATE_REGEX = /\{\{(.*?)\}\}/g;

function getAllTemplateParameters(text) {
  const templateParameters = [...text.matchAll(TEMPLATE_REGEX)].map(
    (m) => m[1]
  );

  return templateParameters;
}

function getTemplateHeaderComponent(template) {
  return template.components.find(
    (component) => component.type === "HEADER" && component.format === "text"
  );
}

function getTemplateBodyComponent(template) {
  return template.components.find((component) => component.type === "BODY");
}

function getTemplateContent(template) {
  const headerComponent = getTemplateHeaderComponent(template);
  const bodyComponent = getTemplateBodyComponent(template);

  return {
    header: headerComponent?.text || "",
    body: bodyComponent?.text || "",
  };
}

function processTemplateForParameters(template) {
  const { components } = template;

  let templateParameters = [];

  const headerComponent = components.filter(
    (component) => component.type === "HEADER" && component.format === "text"
  );

  const bodyComponent = components.filter(
    (component) => component.type === "BODY"
  );

  if (Boolean(headerComponent.length)) {
    const headerComponentText = headerComponent[0].text;
    const _templateParameters = getAllTemplateParameters(headerComponentText);

    templateParameters = [...templateParameters, ..._templateParameters];
  }

  if (Boolean(bodyComponent.length)) {
    const bodyComponentText = bodyComponent[0].text;
    const _templateParameters = getAllTemplateParameters(bodyComponentText);

    templateParameters = [...templateParameters, ..._templateParameters];
  }

  return templateParameters;
}

function generateTemplateForParameter(parameter) {
  const template = {
    name: parameter,
    label: parameter,
    type: "textArea",
    style: {
      height: "50px", fontSize: "13px"
    }
  };

  return template;
}

function generateFormTemplateForParameters(parameters) {
  const formTemplateForParameters = parameters.map((parameter) =>
    generateTemplateForParameter(parameter)
  );

  return formTemplateForParameters;
}

function generateSchemaForParamter(parameter) {
  const schema = {
    [parameter]: Joi.string().required(),
  };

  return schema;
}

function generateFormSchemaForParameters(parameters) {
  const formSchemaForParameters = parameters.reduce((acc, parameter) => {
    const parameterSchema = generateSchemaForParamter(parameter);
    return {
      ...acc,
      ...parameterSchema,
    };
  }, {});

  return formSchemaForParameters;
}

function generateInputFieldForParameters(parameters) {
  const inputFieldForParameters = parameters.reduce((acc, parameter) => {
    return {
      ...acc,
      [parameter]: "",
    };
  }, {});

  return inputFieldForParameters;
}

export {
  getTemplateContent,
  processTemplateForParameters,
  generateFormSchemaForParameters,
  generateFormTemplateForParameters,
  generateInputFieldForParameters,
};
